import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from "rxjs";
import { Table } from "primeng/table";
// Model
import { OutgoingEventsHybridModel, OutgoingEventsHybridParamsModel } from "./model/outgoing-events-hybrid";
import { BroadcastService, ModalService, ModalSize } from "@cv-invision/core";
// Service
import { OutgoingEventsHybridService } from "./service/outgoing-events-hybrid.service";
// Component
import { IntegrationsUrlParamsModel } from "../generic-integrations/models/integrations-url-params.model";
import { EditModalComponent } from "./components/edit-modal.component";
@Component({
	selector: 'cv-outgoing-events-hybrid',
	styleUrls: ['./outgoing-events-hybrid.component.scss'],
	templateUrl: './outgoing-events-hybrid.component.html',
	providers: [ConfirmationService, MessageService]
})
export class OutgoingEventsHybridComponent  implements OnInit, OnDestroy {
	public data: any = [];
	public label = 'Outgoing Events Hybrid'
	public modalSize = ModalSize.LG;
	public extraData: any;
	public outgoingParams: IntegrationsUrlParamsModel;
	public clonedData: any = [];
	public searchField: string;

	public clientIdentifiers: any = [];

	@Input() formBuilderConfig: any;
	@Input() model: any;
	@ViewChild('dt') dataTable: any;

	private atComponentDestroy: Subject<any> = new Subject<any>();
	public integrationParams = new OutgoingEventsHybridParamsModel()
	public integrationExtraData: any = {};
	public integrations: any;

	constructor(
		public confirmationService: ConfirmationService,
		protected service: OutgoingEventsHybridService,
		protected modalService: ModalService,
		public messageService: MessageService,
		protected componentFactoryResolver: ComponentFactoryResolver,
		protected broadcast: BroadcastService
	) { 
	
	}

	async ngOnInit(): Promise<void> {
		this.searchField = '';
		this.model = OutgoingEventsHybridModel;
		this.loadData();
	}

	/**
	 * Edit the integration
	 * @param integrationName string
	 */
	editIntegration(integrationName: string): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: EditModalComponent,
				data: {
					integrationName
				},
				modalConfiguration: {
					title: `${integrationName} Outgoing Events`,
					modalSize: ModalSize.LG
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					// this.ciJobTypesService.setReloadListConfirmation({
					// 	reloadList: true
					// });
				} else {
					// it failed :(
				}
			});
	}

	/**
	 * Get fields for global filter
	 * @returns
	 */
	getGlobalFilters(): Array<any> {
		return this.model.map((field: { key: any }) => field.key);
	}

	/**
	 * Remove changes from cloned array if edit is cancelled
	 * @param row
	 * @param index
	 */
	onRowEditCancel(row: any, index: number) {
		this.data[index] = this.clonedData[row.id];
		delete this.clonedData[row.id];
	}

	/**
	 * Get the data from the service
	 */
	loadData() {
		this.service
			.getIntegrationListNonGeneric(this.integrationParams)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result: string[]) => {
				this.integrations = result.map((row: any, index: any) => (
					{
						...{ id: index },
						name: row
					}
				));
			});
	}

	/**
	 * Apply Global Filter
	 * @param $event
	 * @param table
	 */
	applyGlobalFilter($event: any, table: Table): void {
		table.filterGlobal($event.target.value, 'contains');
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}